import React from "react";
import { Controller } from "react-hook-form";
import { Form, Row, Col, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ControlledTextArea from "../../components/ControlledTextArea";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";
import { getError } from "../../utils/form";

function itemLayout(fullLabelWidth) {
  let layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      lg: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      lg: { span: 14 },
    },
  };

  if (fullLabelWidth === true) {
    layout.labelCol.lg.span = 24;
  }

  return layout;
}
export const ControlledUpload = ({ control, name, label, errors, required, acceptType, maxCount, fullLabelWidth=false  }) => {
  const error = getError({ errors, name });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          {...itemLayout(fullLabelWidth)}
          label={label}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Upload
            {...field}
            fileList={field.value || []}
            accept={acceptType || "image/*"}
            listType="picture"
            beforeUpload={() => false} // prevent auto upload
            maxCount={maxCount}
            multiple={true}
            onChange={({ fileList }) => field.onChange(fileList)}
            onPreview={(file) => {
              const imageUrl =
                file.url || URL.createObjectURL(file.originFileObj);
              window.open(imageUrl, "_blank");
            }}
          
            
          >
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Form.Item>
      )}
    />
  );
};
const rejectionOptions = [
  {
    label: "Image Mismatch – Different Sample Received",
    value: "Image Mismatch – Different Sample Received",
  },
  {
    label: "Out of Scope Sample Received",
    value: "Out of Scope Sample Received",
  },
  { label: "Expired Sample", value: "Expired Sample" },
  { label: "Damaged Sample Received", value: "Damaged Sample Received" },
  {
    label: "Incorrect Sample Variant/Type",
    value: "Incorrect Sample Variant/Type",
  },
  {
    label: "Insufficient Quantity",
    value: "Insufficient Quantity",
  },
];

function OrderRejectionForm({ rejectOrderId, control, errors }) {

  return (
    <Form>
      <h2>Are you sure you want to reject this order?</h2>
      <Row gutter={24} style={{ marginBottom: "16px" }}>
        <Col span={24}>
          <div
            style={{
              backgroundColor: "#f5f5f5",
              padding: "12px 16px",
              borderRadius: "4px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>Order ID:</span>{" "}
            {rejectOrderId}
          </div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="rejectionReason"
            label="Rejection Reason"
            placeholder="Select a reason for rejecting this order"
            options={rejectionOptions}
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24} style={{ marginTop: "8px" }}>
        <Col span={24}>
          <ControlledUpload
            control={control}
            name="rejectionImages"
            label="Upload 2 Supporting Images"
            errors={errors}
            required
            acceptType="image/*"
            maxCount={2}
          />
        </Col>
      </Row>
      <Row gutter={24} style={{ marginTop: "8px" }}>
        <Col span={24}>
          <ControlledTextArea
            control={control}
            name="rejectionRemarks"
            label="Rejection Remarks"
            placeholder="Please provide a reason for rejecting this order..."
            errors={errors}
          />
        </Col>
      </Row>
    </Form>
  );
}

export default OrderRejectionForm;
